import * as io from 'io-ts';

export const boolean = io.boolean;
export const nullableBoolean = io.union([io.boolean, io.null]);
